import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/kush-me/tek_img_03.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={509}
              height={574}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>
              The <span style={{ color: "#49A950" }}>Introduction</span>
            </h2>
            <p>
              Our development and marketing teams met a hefty collaboration,
              resulting in a user-friendly app, that contained each dispensary’s
              operation times and other helpful details to aid users in placing
              orders. To enable accurate location mapping, we integrated the app
              with Google’s user-centric APIs. This ensured a smooth and
              seamless user journey, through every step of the way.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
